import { defineComponent as p, openBlock as o, createElementBlock as a, mergeProps as i, unref as e, renderSlot as u, createElementVNode as n, createCommentVNode as H } from "vue";
import { useScalarIcon as g } from "../hooks/useScalarIcon.js";
const h = { key: 0 }, m = { key: 1 }, M = { key: 2 }, Z = { key: 3 }, V = { key: 4 }, f = { key: 5 }, k = {
  name: "ScalarIconAnchorSimple"
}, _ = /* @__PURE__ */ p({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: A, weight: l } = g(s);
    return (d, t) => (o(), a("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(A)), [
      u(d.$slots, "default"),
      e(l) === "bold" ? (o(), a("g", h, t[0] || (t[0] = [
        n("path", { d: "M224,108H200a12,12,0,0,0,0,24h11.15A84.21,84.21,0,0,1,140,203.14V97.94a36,36,0,1,0-24,0v105.2A84.21,84.21,0,0,1,44.85,132H56a12,12,0,0,0,0-24H32a12,12,0,0,0-12,12,108,108,0,0,0,216,0A12,12,0,0,0,224,108ZM128,52a12,12,0,1,1-12,12A12,12,0,0,1,128,52Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (o(), a("g", m, t[1] || (t[1] = [
        n("path", {
          d: "M152,64a24,24,0,1,1-24-24A24,24,0,0,1,152,64Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M224,112H200a8,8,0,0,0,0,16h15.64A88.15,88.15,0,0,1,136,207.63V95a32,32,0,1,0-16,0V207.63A88.15,88.15,0,0,1,40.36,128H56a8,8,0,0,0,0-16H32a8,8,0,0,0-8,8,104,104,0,0,0,208,0A8,8,0,0,0,224,112ZM112,64a16,16,0,1,1,16,16A16,16,0,0,1,112,64Z" }, null, -1)
      ]))) : e(l) === "fill" ? (o(), a("g", M, t[2] || (t[2] = [
        n("path", { d: "M232,120a104,104,0,0,1-208,0,8,8,0,0,1,8-8H56a8,8,0,0,1,0,16H40.36A88.15,88.15,0,0,0,120,207.63V90.83a28,28,0,1,1,16,0v116.8A88.15,88.15,0,0,0,215.64,128H200a8,8,0,0,1,0-16h24A8,8,0,0,1,232,120Z" }, null, -1)
      ]))) : e(l) === "light" ? (o(), a("g", Z, t[3] || (t[3] = [
        n("path", { d: "M224,114H200a6,6,0,0,0,0,12h17.8A90.13,90.13,0,0,1,134,209.78V93.4a30,30,0,1,0-12,0V209.78A90.13,90.13,0,0,1,38.2,126H56a6,6,0,0,0,0-12H32a6,6,0,0,0-6,6,102,102,0,0,0,204,0A6,6,0,0,0,224,114ZM110,64a18,18,0,1,1,18,18A18,18,0,0,1,110,64Z" }, null, -1)
      ]))) : e(l) === "regular" ? (o(), a("g", V, t[4] || (t[4] = [
        n("path", { d: "M224,112H200a8,8,0,0,0,0,16h15.64A88.15,88.15,0,0,1,136,207.63V95a32,32,0,1,0-16,0V207.63A88.15,88.15,0,0,1,40.36,128H56a8,8,0,0,0,0-16H32a8,8,0,0,0-8,8,104,104,0,0,0,208,0A8,8,0,0,0,224,112ZM112,64a16,16,0,1,1,16,16A16,16,0,0,1,112,64Z" }, null, -1)
      ]))) : e(l) === "thin" ? (o(), a("g", f, t[5] || (t[5] = [
        n("path", { d: "M224,116H200a4,4,0,0,0,0,8h19.91A92.13,92.13,0,0,1,132,211.91V91.71a28,28,0,1,0-8,0v120.2A92.13,92.13,0,0,1,36.09,124H56a4,4,0,0,0,0-8H32a4,4,0,0,0-4,4,100,100,0,0,0,200,0A4,4,0,0,0,224,116ZM108,64a20,20,0,1,1,20,20A20,20,0,0,1,108,64Z" }, null, -1)
      ]))) : H("", !0)
    ], 16));
  }
});
export {
  _ as default
};
